import { Component, OnInit, Input, Host, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DiFormService } from 'src/app/di-core/service/di-form-service/di-form.service';
import { DiFormComponent } from '../../di-form/di-form.component';

@Component({
  selector: 'di-select',
  templateUrl: './di-select.component.html',
  styleUrls: ['./di-select.component.scss']
})
export class DiSelectComponent {
  @Input() placeholder: string;
  @Input() fcName: string;
  @Input() hintMessage: string;
  @Input() isAddNew: boolean = false;

  @Input() options: Array<any> = [];
  @Input() value: string;
  @Input() dv: string;
  
  @Output() onAddNew = new EventEmitter();
  

  diForm: DiFormComponent
  formGroup: FormGroup;
  errorMessage: string;

  constructor(@Host() diForm: DiFormComponent, private formService: DiFormService) {
    let component = this;
    component.diForm = diForm;
  }
  ngOnInit(): void {
    let component = this;
    component.formService.initFormGroup$.subscribe(initFormGroup => {
      if (initFormGroup == component.diForm.formGroup) {
        component.formGroup = component.diForm.formGroup;
      }
    })
  }
  addNew(event){
    let component = this;
    event.stopPropagation();
    component.onAddNew.emit(event)
  }
}

